/**
 * Copy the home page shows below its H1 (web plan W0.6).
 *
 * Pure module (no `window`, no React), so the SEO server (plan W1) and the
 * framework-mode home route (W4) can render the same text.
 */

/**
 * OWNER CONTENT: the homepage intro — 60–150 words of original copy that
 * mention Pakistan and the main cities and categories naturally (web plan
 * "What I need" #2, master §4 #9). Separate paragraphs with a blank line.
 *
 * Empty until the owner supplies it; the home page renders nothing for it
 * until then. Never fill it with placeholder or generated text.
 */
export const HOME_INTRO = '';

/** The intro as paragraphs: split on blank lines, whitespace collapsed, empties dropped. */
export function introParagraphs(text: string = HOME_INTRO): string[] {
  return text
    .split(/\n\s*\n/)
    .map((paragraph) => paragraph.replace(/\s+/g, ' ').trim())
    .filter(Boolean);
}
